import { render, staticRenderFns } from "./MedicineAssessment.vue?vue&type=template&id=1dad200e"
import script from "./MedicineAssessment.vue?vue&type=script&lang=js"
export * from "./MedicineAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports